import { lazy, Suspense, useEffect, useRef, useState } from "react";

const RegionalMap = lazy(() => import("./RegionalMap"));

/**
 * El visor pesa más que el resto de la página junta, así que solo se monta
 * cuando la sección se acerca a la pantalla. En un teléfono con datos, quien
 * no baja hasta el mapa no lo descarga.
 */
export function MapSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [mount, setMount] = useState(false);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    if (!("IntersectionObserver" in window)) {
      setMount(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setMount(true);
        observer.disconnect();
      },
      { rootMargin: "600px 0px" },
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="map-section" ref={sectionRef}>
      <div className="map-section-heading">
        <h2>
          Recorra el sitio <span>en 3D</span>
        </h2>
        <p>
          La torre a escala real sobre el relieve del volcán. Active{" "}
          <b>Línea de vista</b> para ver hasta dónde llega la visión directa
          desde la punta.
        </p>
      </div>
      <div className="map-workspace" aria-label="Mapa 3D del predio">
        {mount ? (
          <Suspense
            fallback={
              <div className="map-loading">
                <span aria-hidden="true" />
                Cargando el visor 3D…
              </div>
            }
          >
            <RegionalMap />
          </Suspense>
        ) : (
          <div className="map-loading" aria-hidden="true" />
        )}
      </div>
    </section>
  );
}
